import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { IconGroup } from 'components/atoms/icons/IconGroup';

import { Tenant } from 'components/molecules/SelectTenantCard';

interface Props {
  tenants: Tenant[];
  onTenantSelect: (tenant: Tenant) => void;
}

export const TenantListContent = ({ tenants, onTenantSelect }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.tenantListContainer}>
      <h2 className={styles.title}>{t('tenant_list.title')}</h2>
      <div className={styles.content}>
        {tenants.map((tenant) => (
          <div
            key={tenant.id}
            className={styles.tenantItem}
            onClick={() => onTenantSelect(tenant)}
          >
            <div className={styles.icon}>
              <IconGroup />
            </div>
            <span className={styles.tenantName}>{tenant.name}</span>
            <span className={styles.section}>
              {tenant.section?.name && <span>{tenant.section.name}</span>}
              {tenant.section?.name && tenant.floor?.name && <span> / </span>}
              {tenant.floor?.name && <span>{tenant.floor.name}</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
